"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.provider.stripe.description': 'Płać kartami kredytowymi, debetowymi i portfelami cyfrowymi za pomocą Stripe',
};
